import type { MuiTheme as Theme } from '@paintscout/ui'
import { makeStyles } from '@paintscout/ui'

export const useTrialDashboardMobileTypographyStyles = makeStyles((theme: Theme) => ({
  heading: {
    fontFamily: 'Euclid',
    fontSize: '1.925rem',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '1.88rem',
    letterSpacing: '-0.0385rem',
    marginBottom: theme.spacing(2),
    color: theme.palette.text.primary,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.65rem',
      lineHeight: '1.62rem',
      letterSpacing: '-0.033rem'
    },
    '@media (min-width: 600px) and (max-width: 1024px)': {
      fontSize: '2.75rem',
      lineHeight: '2.65rem',
      letterSpacing: '-0.055rem'
    },
    '@media (min-width: 600px) and (max-width: 960px) and (min-height: 1025px) and (max-height: 1213px)': {
      fontSize: '3.1rem',
      lineHeight: '3rem',
      letterSpacing: '-0.062rem'
    }
  },
  headingFirstLine: {
    fontFamily: 'Euclid',
    whiteSpace: 'nowrap',
    display: 'block',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      whiteSpace: 'normal'
    },
    '@media (min-width: 600px) and (max-width: 1024px)': {
      whiteSpace: 'normal'
    }
  },
  headingSecondLine: {
    fontFamily: 'Euclid',
    whiteSpace: 'nowrap',
    display: 'block',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      whiteSpace: 'normal'
    },
    '@media (min-width: 600px) and (max-width: 1024px)': {
      whiteSpace: 'normal'
    }
  },
  headingHighlight: {
    color: theme.palette.primary.main
  },
  description: {
    fontFamily: 'Euclid',
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '24px',
    letterSpacing: 0,
    color: '#394860',
    marginBottom: theme.spacing(4),
    textAlign: 'center',
    whiteSpace: 'normal',

    [theme.breakpoints.down('xs')]: {
      fontSize: '16px',
      lineHeight: '22px',
      marginBottom: theme.spacing(3),
      whiteSpace: 'normal'
    },

    [theme.breakpoints.up('sm')]: {
      fontSize: '18px',
      lineHeight: '24px'
    },

    '@media (min-width: 600px) and (max-width: 1024px)': {
      whiteSpace: 'nowrap'
    }
  },
  button: {
    fontFamily: 'Euclid',
    padding: theme.spacing(1.25, 3),
    fontSize: '0.875rem',
    textTransform: 'none',
    borderRadius: theme.shape.borderRadius,
    alignSelf: 'center',
    marginBottom: theme.spacing(3),

    '@media (max-width: 599px)': {
      marginBottom: theme.spacing(6),
      padding: theme.spacing(1, 2.5),
      fontSize: '0.875rem'
    },
    '@media (min-width: 600px) and (max-width: 1024px)': {
      padding: theme.spacing(1.25, 3),
      fontSize: '0.875rem'
    }
  }
}))
